import React, { Component }      from 'react';
import { withRouter }            from 'react-router';
import { connect }               from 'react-redux';
import { Input, Alert }          from 'reactstrap';
import { ClipLoader }            from 'react-spinners';
import { FaTrash }               from 'react-icons/fa';
import PubSub                    from 'pubsub-js';
import { TestConstants }         from '../environment';
import { addFetchData }          from '../../../../actions/test-maintenance/untouchables';
import { untouchablesFetchData } from '../../../../actions/test-maintenance/untouchables';
import { removeFetchData }       from '../../../../actions/test-maintenance/remove';
import { isInRoleFromToken }     from '../../../../utils/authService';

var apiHost = TestConstants.WebApiHost;

class Untouchables extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      add: '',
      message: ''
    };
    
    this.add            = this.add.bind(this);
    this.remove         = this.remove.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.removeComplete = this.removeComplete.bind(this);
    this.addComplete    = this.addComplete.bind(this);
  }
  
  componentDidMount() {
    this.props.fetchDataAdd(apiHost, null, true);
    this.props.fetchDataList(apiHost);
    this.tokenA = PubSub.subscribe('test.maintenance.remove', this.removeComplete.bind(this));
    this.tokenB = PubSub.subscribe('test.maintenance.add', this.addComplete.bind(this));
  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.tokenA);
    PubSub.unsubscribe(this.tokenB);
  }
  
  add() {
    if (this.state.add.length > 1) {
      this.setState({ message: '' }, function() {
        this.props.fetchDataAdd(apiHost, { Key: this.state.add });
      });
    }
  }
  
  addComplete(msg, data) {
    this.setState({ add: '' }, function() {
      this.props.fetchDataList(apiHost);
    });
  }
  
  remove(id) {
    this.props.fetchDataRemove(apiHost, { Id: id });
  }
   
  removeComplete(msg, data) {
    this.props.fetchDataList(apiHost);
  }
   
  handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.add();
    }
  }
  
  updateAdd(event) {
    this.setState({ add: event.target.value.toLowerCase() });
  }

  render() {
    var adminAdd = null;
    if (isInRoleFromToken(TestConstants.AdminRole)) {
      adminAdd = 
        <div>
          <a href="https://services.dev.boisestate.edu/untouchables">Access New Untouchables Tool</a>
        </div>;
    }
    
    return (
      <div style={{ marginBottom: '20px' }}>
        { this.props.addHasErrored ?
          <Alert color='danger' style={{ opacity: 'inherit' }}>
            There was an error adding the user
          </Alert>
          :
          <span></span>
        }
        {adminAdd}
        <div style={{marginTop: '10px'}}>
          { this.props.listIsLoading ?
              <ClipLoader
                color={'#072659'} 
                loading={this.props.listIsLoading} 
              />
              : <span />
          }
          { this.props.addIsLoading ?
              <ClipLoader
                color={'#072659'} 
                loading={this.props.addIsLoading} 
              />
              : <span />
          }
          { this.props.removeIsLoading ?
              <ClipLoader
                color={'#072659'} 
                loading={this.props.removeIsLoading} 
              />
              : <span />
          }
        </div>
        { this.props.list && this.props.list.length > 0 ?
          <ul>
            {
              this.props.list.map((element, index) => 
                <li key={element.Id}>{element.UserName}
                {
                  isInRoleFromToken(TestConstants.AdminRole) 
                  ? 
                  <button onClick={() => {this.remove(element.Id)}}>
                    <FaTrash size={20} />
                  </button>
                  :
                  <span></span>
                }
                </li>
              )}
          </ul>
          :
          <div></div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    add: state.testM.untouchables.add,
    addHasErrored: state.testM.add.addHasErrored,
    addIsLoading: state.testM.add.addIsLoading,
    remove: state.testM.remove.remove,
    removeHasErrored: state.testM.remove.removeHasErrored,
    removeIsLoading: state.testM.remove.removeIsLoading,
    list: state.testM.untouchables.untouchables,
    listHasErrored: state.testM.untouchables.untouchablesHasErrored,
    listIsLoading: state.testM.untouchables.untouchablesIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataAdd:    (host, params, reset) => dispatch(addFetchData(host, params, reset)),
    fetchDataRemove: (host, params)        => dispatch(removeFetchData(host, params)),
    fetchDataList:   (host)                => dispatch(untouchablesFetchData(host))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Untouchables));
